const CORES_PADRAO = {
    neutra: "#fff",
    leve: "#eeff41",
    elevada: "#ba2825",
};

/**
 * Cor do texto de "Faturas do Ciclo" para unidade sazonal.
 * Leve: até 4 faturas restantes e no máximo 2 demandas atingidas.
 * Elevada: até 3 faturas restantes e no máximo 1 demanda atingida.
 * @param {{ atingidas: number, competencias: number, lidas: number, cores?: { neutra?: string, leve?: string, elevada?: string } }} params
 * @returns {string}
 */
export function classificarCorRiscoDemandaComplementarSazonal({ atingidas, competencias, lidas, cores = {} } = {}) {
    const coresAplicadas = { ...CORES_PADRAO, ...cores };
    const restantes = competencias - lidas;

    if (atingidas < 3) {
        if (restantes <= 3 && atingidas <= 1) return coresAplicadas.elevada;
        if (restantes <= 4 && atingidas <= 2) return coresAplicadas.leve;
    }

    return coresAplicadas.neutra;
}
